import moment from 'moment'

export const getReportAge = (timestamp: string) => {
    const now = moment(new Date())
    const end = moment(new Date(timestamp))
    const duration = moment.duration(now.diff(end))
    return duration.asDays()
}
